/**
 * @file components/TokenRevealModal.jsx
 * @description One-time plaintext token reveal, shown after regenerating a token's secret.
 * @param {Object}   props
 * @param {string|null} props.token   - Plaintext value to reveal, or null to hide the modal.
 * @param {Function} props.onClose    - Called when the user dismisses the modal.
 */

import React, { useState } from 'react';

export default function TokenRevealModal({ token, onClose }) {
  const [copied, setCopied] = useState(false);

  if (!token) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(token).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true" aria-labelledby="reveal-title">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header" style={{ backgroundColor: 'var(--color-primary)', color: 'var(--color-text-light)' }}>
              <h5 className="modal-title" id="reveal-title">
                <i className="bi bi-key-fill me-2" aria-hidden="true" />
                Token Regenerated
              </h5>
              <button type="button" className="btn-close btn-close-white" onClick={onClose} aria-label="Close" />
            </div>
            <div className="modal-body">
              <div className="alert alert-warning d-flex align-items-center gap-2 mb-3">
                <i className="bi bi-exclamation-triangle-fill fs-5" aria-hidden="true" />
                The previous token value is now invalid. Copy the new value below — it will not be shown again.
              </div>
              <div className="input-group">
                <input type="text" className="form-control font-monospace" readOnly value={token} aria-label="Regenerated token value" />
                <button
                  className="btn"
                  style={{ backgroundColor: copied ? 'var(--color-accent-2)' : 'var(--color-accent-1)', color: '#000' }}
                  type="button"
                  onClick={handleCopy}
                  aria-label="Copy token to clipboard"
                >
                  <i className={`bi ${copied ? 'bi-check2' : 'bi-clipboard'} me-1`} aria-hidden="true" />
                  {copied ? 'Copied!' : 'Copy'}
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>Done</button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" onClick={onClose} aria-hidden="true" />
    </>
  );
}
